import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "./index.css";
import App from "./App";
import env from "./utils/env";

import "bootstrap/dist/css/bootstrap.css";

// Polyfill para process.env - compatibilidad con código legacy
if (typeof globalThis !== "undefined" && !globalThis.process) {
	globalThis.process = {
		env: {
			REACT_APP_API_URL: import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL,
			REACT_APP_VERSION: import.meta.env.VITE_VERSION || import.meta.env.REACT_APP_VERSION,
			REACT_APP_SENTRY_DSN:
				import.meta.env.VITE_SENTRY_DSN ||
				import.meta.env.VITE_SENTRY_DNS ||
				import.meta.env.REACT_APP_SENTRY_DSN ||
				import.meta.env.REACT_APP_SENTRY_DNS,
			REACT_APP_SENTRY_DNS: import.meta.env.VITE_SENTRY_DNS || import.meta.env.REACT_APP_SENTRY_DNS,
			REACT_APP_SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV || import.meta.env.REACT_APP_SENTRY_ENV,
			REACT_APP_API_GO: import.meta.env.VITE_API_GO || import.meta.env.REACT_APP_API_GO,
			NODE_ENV: import.meta.env.MODE,
		},
	};
}

const sentryDsn = env.SENTRY_DSN || env.SENTRY_DNS;
const sentryEnabledModes = ["staging", "production"];
const isSentryEnabledMode = sentryEnabledModes.includes(env.MODE);

if (isSentryEnabledMode && sentryDsn) {
	Sentry.init({
		dsn: sentryDsn,
		environment: env.SENTRY_ENV || env.MODE,
		tracesSampleRate: 0.01,
		autoSessionTracking: false,
	});
}

// Polyfill para findDOMNode - React 19 removió esta función pero react-transition-group@4 aún la necesita
if (!ReactDOM.findDOMNode) {
	ReactDOM.findDOMNode = function (component) {
		if (component == null) {
			return null;
		}
		if (component.nodeType === 1) {
			return component;
		}
		return component;
	};
}

// React 18 way to render
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<Sentry.ErrorBoundary fallback={<p>Ocurrio un error inesperado.</p>}>
		<App />
	</Sentry.ErrorBoundary>,
);
